import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-grid-white.scss";
import {IWebsiteBlackGridWhite} from "./types/IWebsiteBlackGridWhite";

export class WebsiteBlackGridWhiteComponent extends Component {

    public lines: { entries: IWebsiteBlackGridWhite[] }[];

    constructor(lines: { entries: IWebsiteBlackGridWhite[] }[]) {
        super();
        this.lines = lines;

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackGridWhite}"></div>`;
    }

    commit() {
        let f = false;
        this.lines.forEach(line => {
            let lineContainer = this.append(`<div class="${s.line}"></div>`);
            line.entries.forEach(entry => {
                //language=HTML
                let entryContainer = lineContainer.append(`
                    <div class="${s.entry} ${entry.large ? s.large : ``}">
                        <div class="${s.imageContainer}">
                            ${entry.illustration ? `<div class="${s.illus} ${s[entry.illustration]}"></div>` : ``}
                            ${entry.image ? `<img class="${s.img} ${entry.imageLeftBottom ? s.leftBottom : ``}" src="${entry.image}" alt="${entry.imageAlt}"/>` : ``}
                        </div>
                        <h3 class="${s.title}">
                            ${entry.title}
                        </h3>
                        <p class="${s.description}">
                            ${entry.description}
                        </p>
                    </div>
                `);

                this.putListener(window, "scroll", () => {
                    let top = entryContainer.getOffsets().top - window.innerHeight + ((window.innerHeight / 2) - 200);
                    if (top <= 0) {
                        let realTop = Math.abs(top);
                        if (entry.image) {
                            let img = entryContainer.el(s.img);
                            let clampedTop = Math.min(realTop, 250);
                            let translateY = 150 * (1 - clampedTop / 250);
                            let scale = 0.9 + (0.1 * clampedTop / 250);

                            img.setStyle(`transform: translateY(${translateY}px) scale(${scale});`);
                        }
                    } else {
                        if (entry.image) {
                            let img = entryContainer.el(s.img);
                            img.setStyle(`transform: translateY(150px) scale(0.9);`);
                        }
                    }
                });
            });
        });

        super.commit();
    }

}